import React from "react";
import { MdLocationPin } from "react-icons/md";

const PinsMarker = (props) => {
  const { localisation, setCountrySelected } = props;

  const changeCountry = (idLocalisation) => {
    if (setCountrySelected) setCountrySelected(idLocalisation);
    document.getElementById("MapGoogle").style.display = "none";
    scrollBloc("blocAfterMap");
  };

  const scrollBloc = (ID) => {
    setTimeout(function () {
      document.getElementById(ID).scrollIntoView({ behavior: "smooth" });
      document.getElementById("toggleGoogleMap").style.display = "block";
    }, 100);
  };

  return (
    <div className="containerPinsMarker" onClick={(e) => changeCountry(localisation._id)}>
      <MdLocationPin
        size="2.5em"
        className="pinsMarker"
        style={{
          top: "-1.25em",
          left: "-1.25em",
        }}
      />
    </div>
  );
};

export default PinsMarker;
